/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxfHoursV1TransfersScheduleVersionEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXF_HOURS_V1_TRANSFERS_SCHEDULE_VERSION_EVENT_ENTITY_NAME = 'ixf.hours.v1.TransfersScheduleVersionEvent';
export const ixfHoursV1TransfersScheduleVersionEventEntity = new schema.Entity<IxfHoursV1TransfersScheduleVersionEvent>(IXF_HOURS_V1_TRANSFERS_SCHEDULE_VERSION_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxfHoursV1TransfersScheduleVersionEvent) => `${entity.metadata?.eventId}` });

